export const child_hbyc_message = {
    errorMessageforZeroWeight:'Weight should be between 1-20 and upto two decimal places.',
    errorMessageforZeroLength:'Length should be between 1-200 and upto two decimal places.',
    errorMessageWeightOfBaby: 'Weight of baby cannot be blank.',
    errorMessageForLessWeightOfBaby:'Weight of baby cannot be below 500',
    errorMessageLengthOfBaby: 'Length of baby cannot be blank.',
    errorMessageforZoneDetails:'Zone cannot be blank',
    errorMessageChildIsSick: 'Child is sick cannot be blank.',
    errorMessageBreastfeedingContinue: 'Breastfeeding continue cannot be blank.',
    errorMessageRedFlagSign: 'Red flag sign cannot be blank.',
    errorMessageHivTest: 'Hiv Test cannot be blank.',
    errorMessageSyphilisTest: 'Syphilis Test cannot be blank.',
    errorMessageNacpRefferalFacility: 'Referred to NACP referral facility cannot be blank.',
    errorMessageWeatherChildIsReffered: 'Whether child is referred cannot be blank.',
    errorMessageWhetherBottleOfIfaProvided: 'Whether bottle of ifa provided cannot be blank.',
    errorMessageWhetherOrsProvided: 'Whether ors provided cannot be blank.',
    errorMessageWhetherComplementaryFeedingStartedAt6months: 'Whether complementary feeding started at 6 months cannot be blank.',
    errorMessageWhetherComplementaryFeedingAdequatelyProvided: 'Whether complementary feeding adequately provided cannot be blank.',
    errorMessageWhetherChildIsReffered: 'Whether child is reffered cannot be blank.',
    errorgetRedFlagIssueForBaby:'HBYC value is missing. Please check child details or visit date.'
};


export const HBYC_COMMON_CONSTANTS = {
    RED_FLAG_SIGN: 'redFlagSign',
    WHETHER_CHILD_IS_SICK: 'weatherChildIsSick',
    NO_SICKNESS: 'No Sickness',
    NO_RED_FLAG_SIGN: 'No Red Flag Sign',
}